class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.discountCodeWrappers = document.querySelectorAll(
      ".applied-discount-code-wrapper"
    );
    this.clearBtns = document.querySelectorAll("#clear-discount-btn");
    this.applyBtns = document.querySelectorAll("#apply-discount-btn");
    this.applyBtnMsgs = document.querySelectorAll("#apply-discount-message");
    this.discountMessages = document.querySelectorAll(".discount-message-cart");
    this.discountCodeInputs = document.querySelectorAll("#discount-code-input");
    this.discountCodeValues = document.querySelectorAll(
      ".applied-discount-code-value-text"
    );
    this.totalCartprices = document.querySelectorAll(
      ".totals .totals__subtotal-value"
    );
    this.totalCartPriceDiscounts = document.querySelectorAll(
      ".total_reduction .totals__subtotal-value"
    );
    this.sousTotalCartPrices = document.querySelectorAll(
      ".sous_total .totals__subtotal-value"
    );
    this.discountCodeErrors = document.querySelectorAll("#discount-code-error");
    this.updatePriceCart = this.updatePriceCart.bind(this);
    this.errorMessages = {
      fr: "Veuillez entrer un code valide.",
      it: "Inserisci un codice valido.",
      es: "Por favor, ingrese un código válido.",
      de: "Bitte geben Sie einen gültigen Code ein.",
    };

    if (localStorage.discountCode)
      this.applyDiscount(JSON.parse(localStorage.discountCode).code);
  }

  getUserLanguage() {
    // Map of domains to languages
    const domainLanguageMap = {
      "stormrock.fr": "fr",
      "stormrock.it": "it",
      "stormrock.es": "es",
      "stormrock.de": "de",
    };
    let hostname = window.location.hostname;
    if (hostname.startsWith("www.")) {
      hostname = hostname.slice(4);
    }
    console.log(hostname);
    let language = domainLanguageMap[hostname] || "fr";
    console.log(language);

    return language;
  }

  listenEvents() {
    this.applyBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const discountCodeInputs = this.discountCodeInputs;
        discountCodeInputs.forEach((discountCodeInput) => {
          if (discountCodeInput) {
            this.applyDiscount(discountCodeInput.value.trim());
            setTimeout(this.updatePriceCart, 2000);
          } else {
            const userLang = this.getUserLanguage();
            const errorMessage = this.errorMessages[userLang];
            this.discountCodeErrors.forEach((error) => {
              error.innerHTML = errorMessage;
            });
          }
        });
      });
    });

    this.applyBtnMsgs.forEach((btnMsg) => {
      btnMsg.addEventListener("click", () => {
        this.applyDiscount(btnMsg.innerHTML);
        setTimeout(this.updatePriceCart, 2000);
      });
    });

    this.clearBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.clearDiscount();
      });
    });
  }

  // clearLocalStorage() {
  //     this.discountCodeWrappers.forEach(wrapper => {
  //         wrapper.style.display = "none";
  //     });
  //     this.totalCartprices.forEach(price => {
  //         price.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
  //     });
  //     this.sousTotalCartPrices.forEach(price => {
  //         price.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
  //     });
  //     localStorage.removeItem("discountCode");
  //     localStorage.removeItem("price");
  // }

  // clearDiscount() {
  //     this.discountCodeValues.forEach(value => {
  //         value.innerHTML = "";
  //     });
  //     this.discountCodeErrors.forEach(error => {
  //         error.innerHTML = "";
  //     });
  //     this.discountMessages.forEach(message => {
  //         message.style.display = 'block';
  //     });
  //     this.clearLocalStorage();
  //     fetch("/checkout?discount=%20");
  // }

  async applyDiscount(code) {
    this.applyBtns.forEach((btn) => {
      btn.innerHTML = "CHARGEMENT <div class='loader'></div>";
      btn.style.pointerEvents = "none";
    });

    fetch("/payments/config", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        const checkout_json_url = "/wallets/checkouts/";
        let authorization_token = btoa(data.paymentInstruments.accessToken);
        fetch("/cart.js", {})
          .then((res) => res.json())
          .then((data) => {
            let body = {
              checkout: {
                country: Shopify.country,
                discount_code: code,
                line_items: data.items,
                presentment_currency: Shopify.currency.active,
              },
            };

            fetch(checkout_json_url, {
              headers: {
                accept: "*/*",
                "cache-control": "no-cache",
                authorization: "Basic " + authorization_token,
                "content-type": "application/json, text/javascript",
                pragma: "no-cache",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-origin",
              },
              referrerPolicy: "strict-origin-when-cross-origin",
              method: "POST",
              mode: "cors",
              credentials: "include",
              body: JSON.stringify(body),
            })
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                if (data.checkout) {
                  let discountApplyUrl =
                    "/discount/" +
                    code +
                    "?v=" +
                    Date.now() +
                    "&redirect=/checkout/";
                  fetch(discountApplyUrl, {}).then(function (response) {
                    return response.text();
                  });
                  data.checkout.applied_discounts.forEach((el) => {
                    this.discountCodeValues.forEach((value) => {
                      value.innerHTML =
                        el.title +
                        " (-" +
                        el.amount +
                        " " +
                        Shopify.currency.active +
                        ")";
                    });
                  });

                  this.discountCodeWrappers.forEach((wrapper) => {
                    wrapper.style.display = "flex";
                    wrapper.style.justifyContent = "flex-end";
                    wrapper.style.marginBottom = "5px";
                  });

                  this.discountCodeErrors.forEach((error) => {
                    error.innerHTML = "";
                  });
                  let localStorageValue = {
                    code: code.trim(),
                    totalCart: data.checkout.total_line_items_price,
                  };

                  localStorage.setItem(
                    "discountCode",
                    JSON.stringify(localStorageValue)
                  );
                  this.sousTotalCartPrices.forEach((price) => {
                    price.innerHTML = data.checkout.total_price + "€";
                  });
                  this.totalCartPriceDiscounts.forEach((discount) => {
                    discount.innerHTML =
                      "-" + data.checkout.total_line_level_discount + "€";
                  });
                  this.discountMessages.forEach((message) => {
                    message.style.display = "none";
                  });

                  setTimeout(this.updatePriceCart, 2000);
                }
              })
              .finally(() => {
                this.applyBtns.forEach((btn) => {
                  btn.innerHTML = "Appliquer";
                  btn.style.pointerEvents = "all";
                });
              });
          });
      });
  }
  async updatePriceCart() {
    const cartUrls = [];
    this.applyBtns.forEach((btn) => {
      const url = btn.dataset.url;
      if (url) cartUrls.push(url);
    });

    for (const url of cartUrls) {
      try {
        const res = await fetch(url);
        const text = await res.text();

        const html = new DOMParser().parseFromString(text, "text/html");
        const destinations = document.querySelectorAll(".cart-item__details");
        const sources = html.querySelectorAll(".cart-item__details");

        // Update each cart item detail
        destinations.forEach((dest, index) => {
          dest.innerHTML = sources[index].innerHTML;
        });
      } catch (error) {
        console.error("Error updating cart-item prices:", error);
      }
    }
  }

  connectedCallback() {
    this.listenEvents();
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".cart__footer",
      },
      {
        id: "cart-discount",
        section: document.getElementById("cart-discount").dataset.id,
      },
    ];
  }
}

if (!window.customElements.get("cart-discount")) {
  window.customElements.define("cart-discount", CartDiscount);
}
